import React, { useEffect, useState, useRef } from "react";
import Swal from "sweetalert2";
import InputComponent from "../../../components/Input/input";
import Button from "../../../components/Button/button";
import { MdOutlineViewColumn } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import { Label } from "../../../components/Label/styles";
import { IoCloseSharp, IoSearchSharp } from "react-icons/io5";
import { Colors } from "../../../shared/colors/colors";
import {
  ButtonAction,
  Table,
  TableData,
  TableHead,
  TableHeader,
  TableRow,
  TableContainer,
} from "../../../components/Table/styles";
import { Dropdown } from "react-bootstrap";
import {
  MenuTable,
  MenuTableDivider,
  MenuTableItem,
} from "../../../components/Table/styles";
import { SlOptionsVertical } from "react-icons/sl";
import {
  GrayTitle,
  LoadingGif,
  MainContainer,
  TitleAndButton,
} from "../../../shared/styles/global.styles";
import loadSCGif from "../../../assets/load_SC.gif";
import {
  DropdownDivider,
  DropdownScroll,
} from "../../../components/Dropdowns/styles";
import {
  ContainerButtons,
  ContainerFilter,
  InputContainer,
  LoadingContainer,
} from "./styles";
import { StatusRemessa, TypeRemessa } from "../../../shared/enum/remessas.enum";
import { GetRemessasDto } from "../../../shared/dtos/Remessa.dto";
import Pagination from "../../../components/Pagination/pagination";
import RemessasService from "../../../services/RemessaService";
import ModalDetalhes from "../ModalDetalhesRemessa/modalDetalhesRemessa";
import { progressBarSwalAlert } from "../../../components/ProgressBarSwalAlert/ProgressBarSwalAlert";
import requestInProgressService from "../../../services/RequestInProgressService";

interface Props {
  status: StatusRemessa | null;
  setReloadFunction: React.Dispatch<React.SetStateAction<boolean>>;
  editOnly: boolean;
}

const ListarRemessas: React.FC<Props> = ({
  status,
  setReloadFunction,
  editOnly,
}) => {
  const [filteredRemessas, setFilteredRemessas] = useState<GetRemessasDto[]>(
    []
  );
  const [isRequest, setIsRequest] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const [isOpenMenuCollumn, setIsOpenMenuCollumn] = useState(false);
  const [isOpen, setIsOpen] = useState<number | null>(null);
  const [searchValue, setSearchValue] = useState("");
  const [remessasVisibleColumns, setVisibleColumns] = useState<string[]>([]);
  const [tempVisibleColumns, setTempVisibleColumns] = useState<string[]>([]);
  const take = 10;
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [showModalDetails, setShowModalDetails] = useState<boolean>(false);
  const [selectedIdRemittance, setSelectedIdRemittance] = useState<number>(0);
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);

  const defaultColumns = [
    "N° Sequencial",
    "Nome",
    "Remessa de",
    "Status",
    "Criado por",
    "Total de parcelas",
  ];

  const getRemittancesByStatus = async (page: number) => {
    setIsRequest(true);
    try {
      let remittances: GetRemessasDto[] = [];
      let total: number = 0;
      if (status) {
        await RemessasService.getByStatus(status, page, take).then(
          (response) => {
            remittances = response.data;
            total = response.total;
          }
        );
      } else {
        await RemessasService.getAll(page, 10).then((response) => {
          remittances = response.data;
          total = response.total;
        });
      }
      setFilteredRemessas(remittances);
      setTotalPages(Math.ceil(total / 10));
    } catch (error) {
      console.error("Erro ao buscar remessas:", error);
    }
    setIsRequest(false);
  };

  const searchRemittances = async (page: number) => {
    setIsRequest(true);
    try {
      let remittances: GetRemessasDto[] = [];
      let total: number = 0;
      if (status) {
        await RemessasService.getByStatusAndSearch(
          status,
          searchValue,
          page,
          take
        ).then((response) => {
          remittances = response.data;
          total = response.total;
        });
      } else {
        await RemessasService.getBySearch(searchValue, page, 10).then(
          (response) => {
            remittances = response.data;
            total = response.total;
          }
        );
      }
      setFilteredRemessas(remittances);
      setTotalPages(Math.ceil(total / 10));
    } catch (error) {
      console.error("Erro ao buscar remessas:", error);
    }
    setIsRequest(false);
  };

  const updateStatusRemittances = async (id: number, status: StatusRemessa) => {
    let msgQuestion = "";
    switch (status) {
      case StatusRemessa.ENVIADO:
        msgQuestion = "Deseja declarar a remessa como enviada?";
        break;
      case StatusRemessa.CANCELADO:
        msgQuestion = "Deseja cancelar a remessa?";
        break;
      case StatusRemessa.RECEBIDO:
        msgQuestion = "Deseja declarar o recebimento da remessa?";
        break;
      case StatusRemessa.RECUSADA:
        msgQuestion = "Deseja declarar que a remessa foi recusada?";
        break;
      case StatusRemessa.CRIADO:
        msgQuestion = "Deseja restaurar a remessa?";
        break;
    }
    setIsRequest(true);
    try {
      const result = await Swal.fire({
        title: "Confirmar",
        text: msgQuestion,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Cancelar",
        allowOutsideClick: false,
      });

      if (result.isConfirmed) {
        Swal.fire({
          title: "Aguarde",
          text: "Atualizando status da remessa...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        await RemessasService.updateStatus(id, status).then((response) => {
          if (response.success) {
            let msgSuccess = "";
            switch (status) {
              case StatusRemessa.ENVIADO:
                msgSuccess = "Remessa declarada como enviada com sucesso!";
                break;
              case StatusRemessa.CANCELADO:
                msgSuccess = "Remessa cancelada com sucesso!";
                break;
              case StatusRemessa.RECEBIDO:
                msgSuccess = "Remessa declarada como recebida com sucesso!";
                break;
              case StatusRemessa.RECUSADA:
                msgSuccess = "Remessa declarada como recusada com sucesso!";
                break;
              case StatusRemessa.CRIADO:
                msgSuccess = "Remessa restaurada com sucesso!";
                break;
            }
            Swal.fire({
              icon: "success",
              title: "Sucesso",
              text: msgSuccess,
              allowOutsideClick: false,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Erro",
              text: response.message,
              allowOutsideClick: false,
            });
          }
        });
      }
    } catch (error) {
      console.error("Erro ao buscar remessas:", error);
    }
    setIsRequest(false);
    setSearchValue("");
    getRemittancesByStatus(currentPage);
    setReloadFunction(true);
  };

  const cancelRemittance = async (id: number) => {
    setIsRequest(true);
    try {
      const result = await Swal.fire({
        title: "Confirmar",
        text: "Deseja cancelar a remessa?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Cancelar",
        allowOutsideClick: false,
      });

      if (result.isConfirmed) {
        Swal.fire({
          title: "Aguarde",
          text: "Cancelando remessa...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        await RemessasService.cancelRemittance(
          id,
          StatusRemessa.CANCELADO
        ).then(async (responseCancelRemittance) => {
          if (responseCancelRemittance.success) {
            Swal.fire({
              title: "Processando solicitação",
              html: progressBarSwalAlert({
                currentProgress: 0,
                totalProgress: 0,
                color: Colors.primary,
                showProgressText: true,
              }),
              showConfirmButton: false,
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
              },
            });

            let stopLoopCancelRemittance = false;
            let getRequestInProgressCancelRemittance =
              await requestInProgressService.getRequestInProgressById(
                responseCancelRemittance.data.id
              );
            await new Promise((resolve) => setTimeout(resolve, 2000));

            while (!stopLoopCancelRemittance) {
              getRequestInProgressCancelRemittance =
                await requestInProgressService.getRequestInProgressById(
                  responseCancelRemittance.data.id
                );

              if (getRequestInProgressCancelRemittance.finished) {
                stopLoopCancelRemittance = true;
              } else {
                Swal.update({
                  html: progressBarSwalAlert({
                    currentProgress:
                      getRequestInProgressCancelRemittance.currentProgress,
                    totalProgress:
                      getRequestInProgressCancelRemittance.totalProgress,
                    color: Colors.primary,
                    showProgressText: true,
                  }),
                });
                await new Promise((resolve) => setTimeout(resolve, 2000));
              }
            }
            await requestInProgressService.deleteRequestInProgress(
              responseCancelRemittance.data.id
            );
            if (!getRequestInProgressCancelRemittance.error) {
              Swal.fire({
                title: "Sucesso!",
                text: getRequestInProgressCancelRemittance.message,
                icon: "success",
                confirmButtonText: "OK",
                allowOutsideClick: false,
              });
            } else {
              Swal.fire({
                title: "Erro",
                text: getRequestInProgressCancelRemittance.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false,
              });
            }
          } else {
            Swal.fire({
              title: "Erro",
              text: "Ocorreu um erro ao solicitar a impressão das parcelas. Por favor, tente novamente.",
              icon: "error",
              confirmButtonText: "OK",
              allowOutsideClick: false,
            });
          }
        });
      }
    } catch (error) {
      console.error("Erro ao buscar remessas:", error);
    }
    setIsRequest(false);
    setSearchValue("");
    getRemittancesByStatus(currentPage);
    setReloadFunction(true);
  };

  const loadVisibleColumns = () => {
    try {
      const savedColumns = sessionStorage.getItem(
        `remessas${status}VisibleColumns`
      );
      if (!savedColumns) return setVisibleColumns(defaultColumns);

      const parsedColumns = JSON.parse(savedColumns);
      setVisibleColumns(
        parsedColumns.length > 0 ? parsedColumns : defaultColumns
      );
    } catch (error) {
      console.error("Erro ao carregar colunas:", error);
      return defaultColumns;
    }
  };

  const toggleDropdown = (id: number) => {
    setIsOpen(id === isOpen ? null : id);
  };

  const handleColumnToggle = (column: string) => {
    // Se a coluna é padrão, não permite desmarcar
    if (defaultColumns.includes(column)) {
      return;
    }

    setTempVisibleColumns((prev: string[]) => {
      return prev.includes(column)
        ? prev.filter((col) => col !== column)
        : [...prev, column];
    });
  };

  const handleApplyColumns = () => {
    setVisibleColumns(tempVisibleColumns); // Atualiza as colunas visíveis
    sessionStorage.setItem(
      `remessas${status}VisibleColumns`,
      JSON.stringify(tempVisibleColumns)
    ); // Salva no sessionStorage
    setIsOpenMenuCollumn(false); // Fecha o dropdown
  };

  const typeRemittanceTab = () => {
    switch (status) {
      case StatusRemessa.CRIADO:
        return "Remessas criadas";
      case StatusRemessa.ENVIADO:
        return "Remessas enviadas";
      case StatusRemessa.RECUSADA:
        return "Remessas recusadas";
      case StatusRemessa.CANCELADO:
        return "Remessas canceladas";
      default:
        return "Todas remessas";
    }
  };

  const typeRemittanceEmptyValue = () => {
    switch (status) {
      case StatusRemessa.CRIADO:
        return "Nenhuma remessa criada encontrada";
      case StatusRemessa.ENVIADO:
        return "Nenhuma remessa pendente encontrada";
      case StatusRemessa.RECUSADA:
        return "Nenhuma remessa recusada encontrada";
      case StatusRemessa.CANCELADO:
        return "Nenhuma remessa cancelada encontrada";
      default:
        return "Nenhuma remessa encontrada";
    }
  };

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
    if (searchValue.length > 0) {
      searchRemittances(pageNumber);
    } else {
      getRemittancesByStatus(pageNumber);
    }
  };

  const closeModalDetails = () => {
    setSelectedIdRemittance(0);
    setShowModalDetails(false);
  };

  const openModalDetails = (id: number) => {
    setSelectedIdRemittance(id);
  };

  const downloadRemittance = async (
    name: string,
    codBank: number,
    type: TypeRemessa
  ) => {
    try {
      const typeFolder =
        type === TypeRemessa.BOLETO ? "boleto" : "debito_automatico";
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}remessas/criadas/${codBank}/${typeFolder}/${name}`
      );
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Erro ao fazer download da remessa:", error);
      Swal.fire({
        title: "Erro",
        text: "Ocorreu um erro ao fazer download da remessa. Tente novamente.",
        icon: "error",
        allowOutsideClick: false,
      });
    }
  };

  const handleSearchInput = () => {
    setIsSearch(true);
    if (searchValue.length > 0) {
      setCurrentPage(1);
      searchRemittances(1);
    } else {
      getRemittancesByStatus(currentPage);
    }
  };

  const handleClearSearchInput = () => {
    setIsSearch(false);
    setSearchValue("");
    setCurrentPage(1);
    getRemittancesByStatus(1);
  };

  const handleSearchChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchValue = e.target.value;
    setSearchValue(searchValue);
    if (searchValue === "") {
      handleClearSearchInput();
    }
  };

  useEffect(() => {
    if (selectedIdRemittance !== 0) {
      setShowModalDetails(true);
    }
  }, [selectedIdRemittance]);

  useEffect(() => {
    loadVisibleColumns();
    setSearchValue("");
    getRemittancesByStatus(1);
    setCurrentPage(1);
  }, [status]);

  useEffect(() => {
    // Função para fechar o menu se o clique for fora dele
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownMenuRef.current &&
        !dropdownMenuRef.current.contains(event.target as Node)
      ) {
        setIsOpenMenuCollumn(false); // Fecha o dropdown
      }
    };

    // Adiciona o event listener quando o menu estiver aberto
    if (isOpenMenuCollumn) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    // Limpeza do event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpenMenuCollumn]);

  useEffect(() => {
    if (isOpenMenuCollumn) {
      setTempVisibleColumns(remessasVisibleColumns); // Inicializa o estado temporário com as colunas visíveis atuais
    }
  }, [isOpenMenuCollumn, remessasVisibleColumns]);

  const menuRefsMap = useRef<Map<number, HTMLDivElement | null>>(new Map());
  return (
    <MainContainer>
      <TitleAndButton>
        <GrayTitle>{typeRemittanceTab()}</GrayTitle>
      </TitleAndButton>
      <InputContainer>
        {/* Label para o campo */}
        <Label htmlFor="remessa-sequencial-search" id="pesquisa-sequencial">
          Pesquisar pelo nome, usuário ou número sequencial da remessa:
        </Label>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSearchInput(); // Quando pressionar Enter, ativa a busca
          }}
        >
          <ContainerFilter>
            <InputComponent
              type="text"
              id="search"
              value={searchValue}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const value = e.target.value.replace(".", ",");
                handleSearchChange({
                  ...e,
                  target: { ...e.target, value },
                });
              }}
              placeholder="Busque pelo nome, usuário ou número sequencial da remessa"
              maxLength={45}
              color="black"
              width={399}
              iconRight={
                isSearch ? (
                  <IoCloseSharp size={24} color={Colors.inputIcon} />
                ) : (
                  <IoSearchSharp size={24} color={Colors.inputIcon} />
                )
              }
              onIconRightClick={() => {
                isSearch ? handleClearSearchInput() : handleSearchInput();
              }}
              disabled={isRequest}
            />

            <ContainerButtons>
              <Button
                schemaButton="out-primary"
                action={() => setIsOpenMenuCollumn(!isOpenMenuCollumn)}
                icon={
                  <MdOutlineViewColumn
                    size={20}
                    style={{ marginRight: "8px" }}
                  />
                }
              >
                Selecionar colunas
              </Button>

              <Dropdown.Menu ref={dropdownMenuRef} show={isOpenMenuCollumn}>
                <DropdownScroll>
                  {[
                    "N° Sequencial",
                    "Nome",
                    "Remessa de",
                    "Status",
                    "Criado por",
                    "Criado em",
                    "Total de parcelas",
                    "Valor da remessa",
                  ].map((column, index, array) => (
                    <React.Fragment key={column}>
                      {!defaultColumns.includes(column) && (
                        <Dropdown.Item
                          key={index}
                          eventKey="1"
                          onClick={() => handleColumnToggle(column)}
                          style={{ color: Colors.primary }}
                        >
                          <img
                            src={
                              tempVisibleColumns.includes(column)
                                ? "/images/checkbox-marked.svg"
                                : "/images/checkbox-blank-outline.svg"
                            }
                            alt={
                              tempVisibleColumns.includes(column)
                                ? defaultColumns.includes(column)
                                  ? "Bloqueado"
                                  : "Selecionado"
                                : "Não selecionado"
                            }
                            className="checkbox-image"
                          />
                          <label>{column}</label>
                          {array
                            .filter((col) => !defaultColumns.includes(col))
                            .indexOf(column) <
                            array.filter((col) => !defaultColumns.includes(col))
                              .length -
                              1 && <DropdownDivider />}
                        </Dropdown.Item>
                      )}
                    </React.Fragment>
                  ))}
                </DropdownScroll>
                {JSON.stringify(tempVisibleColumns.sort()) !==
                  JSON.stringify(remessasVisibleColumns.sort()) && (
                  <Dropdown.Item>
                    <MenuTableDivider />
                    <Button
                      schemaButton="with-margin"
                      action={handleApplyColumns} // Aplica as mudanças ao clicar
                    >
                      Aplicar
                    </Button>
                  </Dropdown.Item>
                )}
              </Dropdown.Menu>
            </ContainerButtons>
          </ContainerFilter>
        </form>
      </InputContainer>
      <TableContainer>
        {isRequest ? (
          <LoadingContainer>
            <LoadingGif src={loadSCGif} alt="Carregando..." />
          </LoadingContainer>
        ) : (
          <Table id="remessas-tabela" style={{ margin: "50px  0 150px 0" }}>
            <TableHead>
              <TableRow>
                {remessasVisibleColumns.includes("N° Sequencial") && (
                  <TableHeader>N° Sequencial</TableHeader>
                )}
                {remessasVisibleColumns.includes("Nome") && (
                  <TableHeader>Nome</TableHeader>
                )}
                {remessasVisibleColumns.includes("Remessa de") && (
                  <TableHeader>Remessa de</TableHeader>
                )}
                {remessasVisibleColumns.includes("Status") && (
                  <TableHeader>Status</TableHeader>
                )}
                {remessasVisibleColumns.includes("Criado por") && (
                  <TableHeader>Criado por</TableHeader>
                )}
                {remessasVisibleColumns.includes("Criado em") && (
                  <TableHeader>Criado em</TableHeader>
                )}
                {remessasVisibleColumns.includes("Total de parcelas") && (
                  <TableHeader>Total de parcelas</TableHeader>
                )}
                {remessasVisibleColumns.includes("Valor da remessa") && (
                  <TableHeader>Valor da remessa</TableHeader>
                )}
                {status !== StatusRemessa.CANCELADO &&
                  status !== StatusRemessa.RECUSADA && (
                    <TableHeader>Ações</TableHeader>
                  )}
              </TableRow>
            </TableHead>
            <tbody>
              {filteredRemessas.length > 0 ? (
                filteredRemessas.map((remessas) => (
                  <TableRow key={remessas.id}>
                    {remessasVisibleColumns.includes("N° Sequencial") && (
                      <TableData>{remessas.numeroSequencial}</TableData>
                    )}
                    {remessasVisibleColumns.includes("Nome") && (
                      <TableData>{remessas.name}</TableData>
                    )}
                    {remessasVisibleColumns.includes("Remessa de") && (
                      <TableData>
                        {remessas.localPagamento?.descricao || "-"}
                      </TableData>
                    )}
                    {remessasVisibleColumns.includes("Status") && (
                      <TableData>{remessas.status}</TableData>
                    )}
                    {remessasVisibleColumns.includes("Criado por") && (
                      <TableData>{remessas.user.name}</TableData>
                    )}
                    {remessasVisibleColumns.includes("Criado em") && (
                      <TableData>
                        {remessas.createAt
                          ? new Date(remessas.createAt).toLocaleString(
                              "pt-BR",
                              {
                                timeZone: "America/Sao_Paulo",
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                              }
                            )
                          : "-- / -- / ---- --:--:--"}
                      </TableData>
                    )}
                    {remessasVisibleColumns.includes("Total de parcelas") && (
                      <TableData>
                        {remessas.totalFinancialRecord || 0}
                      </TableData>
                    )}
                    {remessasVisibleColumns.includes("Valor da remessa") && (
                      <TableData>
                        {remessas.valueTotal
                          ? `R$: ${remessas.valueTotal
                              .toFixed(2)
                              .replace(/\./g, ",")
                              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")}`
                          : "0,00"}
                      </TableData>
                    )}
                    {status !== StatusRemessa.CANCELADO &&
                      status !== StatusRemessa.RECUSADA && (
                        <TableData
                          style={{
                            position: "relative",
                            overflow: "visible",
                          }}
                        >
                          <ButtonAction
                            onClick={() => toggleDropdown(remessas.id)}
                            style={{ marginLeft: "auto" }}
                          >
                            {isOpen === remessas.id ? (
                              <IoMdClose
                                cursor={"pointer"}
                                size={20}
                                style={{ color: Colors.primary }}
                              />
                            ) : (
                              <SlOptionsVertical
                                cursor={"pointer"}
                                size={20}
                                style={{ color: Colors.primary }}
                              />
                            )}
                          </ButtonAction>
                          <MenuTable
                            show={isOpen === remessas.id}
                            align="start"
                            onHide={() => setIsOpen(null)}
                            isLastRows={
                              filteredRemessas.indexOf(remessas) <= 2
                                ? false
                                : filteredRemessas.length > 0 &&
                                  filteredRemessas.indexOf(remessas) >=
                                    filteredRemessas.length -
                                      Math.ceil(filteredRemessas.length / 2)
                            }
                            ref={(el: HTMLDivElement | null) => {
                              // Armazena a referência no mapa usando o ID do registro como chave
                              menuRefsMap.current.set(remessas.id, el);
                            }}
                          >
                            {editOnly && status === StatusRemessa.CRIADO && (
                              <>
                                <MenuTableItem
                                  onClick={() => {
                                    updateStatusRemittances(
                                      remessas.id,
                                      StatusRemessa.ENVIADO
                                    );
                                    setIsOpen(null);
                                  }}
                                >
                                  Lançar remessa como enviada
                                </MenuTableItem>
                                <MenuTableDivider />
                                <MenuTableItem
                                  onClick={() => {
                                    cancelRemittance(remessas.id);
                                    setIsOpen(null);
                                  }}
                                >
                                  Cancelar remessa
                                </MenuTableItem>
                                <MenuTableDivider />
                              </>
                            )}

                            <MenuTableItem
                              onClick={() => {
                                downloadRemittance(
                                  remessas.name,
                                  remessas.localPagamento?.banco,
                                  remessas.type
                                );
                                setIsOpen(null);
                              }}
                            >
                              Download da remessa
                            </MenuTableItem>
                            <MenuTableDivider />
                            <MenuTableItem
                              onClick={() => {
                                openModalDetails(remessas.id);
                                setIsOpen(null);
                              }}
                            >
                              Detalhes
                            </MenuTableItem>
                          </MenuTable>
                        </TableData>
                      )}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableData
                    colSpan={remessasVisibleColumns.length + 1}
                    className="text-center text-muted"
                  >
                    {typeRemittanceEmptyValue()}
                  </TableData>
                </TableRow>
              )}
            </tbody>
          </Table>
        )}
      </TableContainer>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
      {showModalDetails && (
        <ModalDetalhes
          show={showModalDetails}
          onClose={closeModalDetails}
          numeroSequencial={
            filteredRemessas
              .find((remessa) => remessa.id === selectedIdRemittance)
              ?.numeroSequencial.toString() || ""
          }
          tipoRemessa={
            filteredRemessas.find(
              (remessa) => remessa.id === selectedIdRemittance
            )?.type === TypeRemessa.BOLETO
              ? "Boleto"
              : "Débito Automático"
          }
          id={selectedIdRemittance}
          type="remessa"
        />
      )}
    </MainContainer>
  );
};

export default ListarRemessas;
